import { render, staticRenderFns } from "./CardMap.vue?vue&type=template&id=0fccfc04&scoped=true&"
import script from "./CardMap.vue?vue&type=script&lang=js&"
export * from "./CardMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fccfc04",
  null
  
)

export default component.exports